var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"team-section-title"},[_vm._t("default"),(_vm.arrow)?_c('i',{staticClass:"icon fr"},[_vm._v("")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }